export default __webpack_public_path__ + "static/media/Eidolon Chestguard.a2944079.jpg";